import Vue from 'vue';
import App from './App.vue';
import router from "@/plugins/router";
import TranslateService from '@/services/Translate/Translate.service.js';
import VueMask from 'v-mask';
import VTooltip from 'v-tooltip';
import dialogPlugin from './plugins/dialogNotifyPlugin';
import './styles/global.css';

Vue.config.productionTip = false;

Vue.prototype.$TranslateService = function () {
  return new TranslateService();
};

Vue.prototype.$_t = function (translateKey) {
  return this.$TranslateService()._t(translateKey);
};

Vue.prototype.$buttonColor = process.env.VUE_APP_BUTTON_COLOR ? process.env.VUE_APP_BUTTON_COLOR : "#000000";
Vue.prototype.$envColor = process.env.VUE_APP_ENV_COLOR ? process.env.VUE_APP_ENV_COLOR : "#000000";
Vue.prototype.$textPrimary = process.env.VUE_APP_ENV_TEXT_PRIMARY_COLOR ? process.env.VUE_APP_ENV_TEXT_PRIMARY_COLOR : "#00E300";
Vue.prototype.$img1 = process.env.VUE_APP_IMG_1 ? process.env.VUE_APP_IMG_1 : "logo-caldeira-vertical-branca.png";
Vue.prototype.$img2 = process.env.VUE_APP_IMG_2 ? process.env.VUE_APP_IMG_2 : "logo-caldeira-vertical-branca.png";
Vue.prototype.$img3 = process.env.VUE_APP_IMG_3 ? process.env.VUE_APP_IMG_3 : "logo-caldeira-vertical-preta.png";

Vue.config.devtools = true;
Vue.use(VueMask);
Vue.use(VTooltip);
Vue.use(dialogPlugin);

// Camada de segurança contra clickjacking
if (window.top !== window.self) {
  // Verifica se o referer é o site permitido
  const allowedOrigin = 'https://plataforma.institutocaldeira.org.br';
  if (document.referrer && !document.referrer.startsWith(allowedOrigin)) {
    window.top.location = window.location;
  }
}

require('purecss');

window.vm = new Vue({
  router,
  data: () => ({
    config: {
      projeto: process.env.VUE_APP_PROJECT_NAME ? process.env.VUE_APP_PROJECT_NAME : 'Imply',
    }
  }),
  render: h => h(App)
}).$mount('#app');
